import * as R from 'ramda'

export const dataSelector = (response: any) => R.propOr({}, 'data', response)
